module.exports = __webpack_public_path__ + "static/media/compass.ef2af813.svg";